export const childIdentity = item => `${item.kind}:${item.key}`;

export function resourceChildren(catalog, parent = '') {
    const resources = catalog?.resources || {};
    const nodes = Object.entries(resources).filter(([, node]) => (node.parent || '') === parent)
        .sort(([a, x], [b, y]) => (x.sort || 0) - (y.sort || 0) || a.localeCompare(b))
        .map(([key]) => ({ kind: 'node', key }));
    const references = (resources[parent]?.references || []).filter(key => resources[key]).map(key => ({ kind: 'reference', key }));
    const available = new Map([...nodes, ...references].map(item => [childIdentity(item), item]));
    const result = [];
    for (const item of resources[parent]?.child_order || []) {
        const identity = childIdentity(item);
        if (available.has(identity)) { result.push(available.get(identity)); available.delete(identity); }
    }
    return [...result, ...available.values()];
}

export function storeChildOrder(catalog, parent, order) {
    order.forEach((item, index) => { if (item.kind === 'node') catalog.resources[item.key].sort = index; });
    const owner = catalog.resources[parent];
    if (!owner) return;
    const references = order.filter(item => item.kind === 'reference').map(item => item.key);
    if (owner.references || references.length) owner.references = references;
    if (references.length && order.some(item => item.kind === 'node')) owner.child_order = order;
    else delete owner.child_order;
}

export function normalizeChildOrders(catalog) {
    if (!Object.values(catalog.resources).some(node => node.child_order)) return catalog;
    const next = JSON.parse(JSON.stringify(catalog));
    for (const [key, node] of Object.entries(next.resources)) {
        if (node.child_order) storeChildOrder(next, key, resourceChildren(next, key));
    }
    return next;
}
